import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import { Description, PromoItem, Title } from "@/ui";

export default function PromoSection({ className, title, description, items }) {
  if (items.map((i) => i.title).join("").length === 0) {
    return null;
  }

  return (
    <div className={clsx(className, classes.section)}>
      <Container className="mw-xl">
        <Row>
          {(title || description) && (
            <Col xs={12} md={4} className="mb-4 mb-md-5">
              <div className="d-flex bg-primary flex-column h-100 p-4">
                <Title title={title} className="text-white" />
                <Description description={description} className="text-white" />
              </div>
            </Col>
          )}
          { items.length > 3 &&
            <>
              <Col xs={12} md={8}>
                <Row>
                  {items.slice(0, 4).map(({ title, img, href }, k) => (
                    <Col key={k} xs={12} md={6} className="mb-4 mb-md-5">
                      <PromoItem className="h-100" title={title} img={img} href={href} />
                    </Col>
                  ))}
                </Row>
              </Col>
              {items.slice(4, items.length).map(({ title, img, href }, k) => (
                <Col key={k} xs={12} md={4} className="mb-4 mb-md-5">
                  <PromoItem className="h-100" title={title} img={img} href={href} />
                </Col>
              ))}
            </>
          }
          { items.length <= 3 &&
              items.map(({ title, img, href }, k) => (
                <Col key={k} xs={12} md={4} className="mb-4 mb-md-5">
                  <PromoItem className="h-100" title={title} img={img} href={href} />
                </Col>
              ))
          }
        </Row>
      </Container>
    </div>
  );
}

PromoSection.defaultProps = {
  className: "bg-light pt-4 pt-md-5",
  title: null,
  items: [],
};

PromoSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.any,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      title: PropTypes.string,
      img: PropTypes.string,
      description: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
};
